import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const TooltipEdge = styled.div`
    position: absolute;
    bottom: -19px;
    left: calc(50% - 10px);
    width: 0;
    height: 0;
    border-color: ${colorsPalettes.carbon[500]} transparent transparent transparent;
    border-width: 10px;
    border-style: solid;
`;

export const Marker = styled(CenteredFlexRow).attrs((props) => ({
    className: "PlainTooltip-container",
}))<{ color?: string }>`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ color }) => color || colorsPalettes.blue[400]};
`;

export const LinkItem = styled.a`
    width: fit-content;
    ${setFontVariant("tooltip", colorsPalettes.blue[300])};
`;

export const AlertIcon = styled(SWReactIcons)`
    path {
        fill-rule: evenodd;
    }
`;

export const MarkerIcon = styled(SWReactIcons)`
    path {
        fill: white;
    }

    height: 12px;
    width: 12px;
`;

export const MarkerTooltip = styled.div.attrs((props) => ({
    className: "PlainTooltip-element",
}))`
    width: 196px;
    padding: 16px;
    bottom: 38px;
`;

export const MarkerTooltipTitle = styled.div`
    ${setFontVariant("listItem4", colorsPalettes.bluegrey[100])};
`;

export const MarkerTooltipDescription = styled.div`
    overflow-wrap: normal;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    ${setFontVariant("input2", colorsPalettes.bluegrey[100])};
`;
